import { createVNode as a, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/BusinessFilledStandard.js";
import o from "../components/PfIcon.js";
const r = (e, s) => {
  const t = {
    ...e,
    ...s.attrs
  };
  return a(o, i(t, {
    icon: n
  }), null);
};
r.displayName = "BusinessFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
